<template>
    <div class="system-parameter">
        <StationSide @node-click="nodeClick"/>
        <div class="frame-content">
            <div class="frame-content-title">系统参数</div>
            <div class="frame-content-card">
                <div :key="index" v-for="(item,index) in sysParamsApiMap" class="parameter-card">
                    <div class="parameter-title">{{ item.name }}</div>
                    <div v-if="item.data && item.data.length > 0" class="parameter-list">
                        <div class="parameter-item" v-for="(pItem, pIdx) in item.data" :key="pIdx">
                            <span class="param-label">{{ pItem.name }}：</span>
                            <span>{{ handleFormat(pItem) }}</span>
                        </div>
                    </div>
                    <div v-else class="parameter-list">
                        <div>
                            <span>暂无数据</span>
                        </div>
                    </div>
                </div>

                <!--                <div class="parameter-card">-->
                <!--                    <div class="parameter-title">新风系统</div>-->
                <!--                    <div class="parameter-list">-->
                <!--                        <div class="parameter-item" v-for="(item, index) in sysParams" :key="index">-->
                <!--                            <span class="param-label">{{ item.name }}:</span>-->
                <!--                            <span>{{ item.value }}</span>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import StationSide from '@/pages/systemMessage/components/stationSide.vue'
import axios from "axios";

export default {
    components: {
        StationSide
    },
    data() {
        return {
            host: '',
            // sysParams: [
            //     {name: '空调模式', value: '值一'},
            //     {name: '下次测试时间', value: '值二'},
            //     {name: '监测颗粒物', value: '值三'},
            //     {name: '参数四', value: '值四'},
            //     {name: '参数五', value: '值五'},
            //     {name: '磁盘剩余空间', value: '值六'},
            // ],
            paramsNameMap: {
                0: {//空调参数
                    ACStatus: '运行状态',
                    ACMode: '空调模式',
                    roomTemp: '环境温度(℃)',
                    roomHumidity: '环境湿度(%)',
                },
                // 1: {},//新风系统
                1: {//门禁
                    doorSignal: '门禁状态',
                },
                2: {//控制单元
                    systemTime: '系统时间',
                    runMode: '运行模式',
                    runStatus: '运行状态',
                    CPU: 'CPU使用率(%)',
                    diskSpace: '磁盘剩余空间(G)',
                    nextTestingTime: '下次测试时间',
                    runCycleInterval: '运行周期间隔(min)',
                    sampleRetentionMethod: '留样方式',
                },
                // 4: {},//控制单元
                3: {//预处理单元
                    settlementMode: '沉降模式',
                    settlingTime: '沉降时间(min)',
                    rawWaterValue: '原水浊度(NTU)',
                    afterSettlingValue: '沉降后浊度(NTU)',
                },
                4: {//UPS
                    powerType: '供电类型',
                    inputVoltage: '输入电压(V)',
                    outputVoltage: '输出电压(V)',
                    loadPercent: '负载百分比(%)',
                    inputFrequency: '输入频率(Hz)',
                    batteryVoltage: '电池电压(V)',
                    batteryLevel: '剩余电量(%)',
                    UPStemp: '温度(℃)',
                },
                // 5: {//纯水机
                //     conductivity: '电导率(uS/cm)',
                //     waterYield: '累计制水(ml)',
                //     changeTime: '滤芯更换时间',
                // },
                // 5: {//质控仪
                //     workStatus: '工作状态',
                //     onlineStatus: '通讯状态',
                // },
                5: { //动环系统
                    Temperature: '环境温度(℃)',
                    Humidity: '环境湿度(%)',
                    ImmersionState: '水浸状态',
                    Smoke: '烟雾',
                    ElectricQuantity: '电量',
                    ElectricityMeter: '电表',
                }
            },
            sysParamsApiMap: [
                {name: '空调参数', url: '/api/water/rtd/getAirConditioningInfo', data: []},
                // {name: '新风系统', url: '/api/water/rtd/getFreshAirSystemInfo', data: []},
                {name: '门禁', url: '/api/water/rtd/getAlarmInfo', data: []},
                {name: '控制单元', url: '/api/water/rtd/getControlInfo', data: []},
                // {name: '控制单元', url: '/api/water/rtd/getWaterSamplingInfo', data: []},
                {name: '预处理单元', url: '/api/water/rtd/getPretreatmentInfo', data: []},
                {name: 'UPS', url: '/api/water/rtd/getUPSInfo', data: []},
                // {name: '纯水机', url: '/api/water/rtd/getPureWaterInfo', data: []},
                //{name: '质控仪', url: '/api/water/rtd/getQCInfo', data: []},
                {name: '动环系统', url: '/api/water/rtd/getMovableringInfo', data: []},
            ]
        }
    },
    methods: {
        // async fetchSysParamsData() {
        //     if (!this.host) {
        //         console.error('Host is not set.');
        //         return;
        //     }
        //     try {
        //         const requests = this.sysParamsApiMap.map(api =>
        //             axios.post(`${this.host}${api.url}`)
        //         );
        //
        //         // 使用 Promise.allSettled 替代 Promise.all
        //         const results = await Promise.allSettled(requests);
        //         console.log('results',results)
        //         results.forEach((result, index) => {
        //             if (result.status === 'fulfilled') {
        //                 // 请求成功
        //                 const response = result.value;
        //                 let resData = response.data.data;
        //                 if (index === 8) {
        //                     resData = resData && resData.length > 0 ? resData[0] : null;
        //                 }
        //                 let properties = this.paramsNameMap[index];
        //                 let targetProps = Object.keys(properties);
        //                 console.log('resData',resData)
        //                 if (resData) {
        //                     const resultArray = [];
        //                     for (let key in resData) {
        //                         if (resData.hasOwnProperty(key) && targetProps.includes(key)) {
        //                             resultArray.push({name: properties[key], prop: key, value: resData[key]});
        //                         }
        //                     }
        //                     this.$set(this.sysParamsApiMap[index], 'data', resultArray);
        //                 }
        //             } else {
        //                 // 请求失败（如404）
        //                 console.error(`${this.sysParamsApiMap[index].name} 请求失败:`, result.reason);
        //                 // 设置默认数据或错误提示
        //                 this.$set(this.sysParamsApiMap[index], 'data', []);
        //                 this.$set(this.sysParamsApiMap[index], 'error', '数据获取失败');
        //             }
        //         });
        //     } catch (error) {
        //         console.error('Error in fetchSysParamsData:', error);
        //     }
        // },
        async fetchSysParamsData() {
            if (!this.host) {
                console.error('Host is not set.');
                return;
            }
            try {
                this.sysParamsApiMap.forEach(async (api, index) => {
                    try {
                        const response = await axios.post(`${this.host}${api.url}`);
                        let resData = response.data.data;
                        if (index === 8) {
                            resData = resData && resData.length > 0 ? resData[0] : null;
                        }
                        let properties = this.paramsNameMap[index];
                        let targetProps = Object.keys(properties);
                        if (resData) {
                            const resultArray = [];
                            for (let key in resData) {
                                if (resData.hasOwnProperty(key) && targetProps.includes(key)) {
                                    resultArray.push({ name: properties[key], prop: key, value: resData[key] });
                                }
                            }
                            this.$set(this.sysParamsApiMap[index], 'data', resultArray);
                        }
                    } catch (error) {
                        console.error(`${api.name} 请求失败:`, error);
                        this.$set(this.sysParamsApiMap[index], 'data', []);
                        this.$set(this.sysParamsApiMap[index], 'error', '数据获取失败');
                    }
                });
            } catch (error) {
                console.error('Error in fetchSysParamsData:', error);
            }
        },
        nodeClick(item) {
            console.log('点击了节点:', item);
            this.reset();
            this.host = item.api;  //示例: http://1677i9j550.51vip.biz
            this.fetchSysParamsData();
        },
        reset() {
            this.host = '';
            this.sysParamsApiMap.forEach(api => {
                api.data = [];
            });
        },
        handleFormat(item) {
            // console.log(item)
            let valueFormat = {};
            if (item.prop === 'ACStatus') {
                // 假设值是时间戳，进行格式化
                valueFormat = {
                    0: '待机',
                    1: '运行',
                };
            } else if (item.prop === 'ACMode') {
                valueFormat = {
                    0: '自动',
                    1: '制冷',
                    2: '制热',
                    3: '除湿',
                    4: '送风',
                };
            } else if (item.prop === 'doorSignal') {
                valueFormat = {
                    0: '关',
                    1: '开',
                };
            } else if (item.prop === 'runMode') {
                valueFormat = {
                    0: '维护模式',
                    1: '常规（间歇）模式',
                    2: '应急（连续）模式',
                    3: '质控模式',
                };
            } else if (item.prop === 'runStatus') {
                valueFormat = {
                    0: '运行',
                    1: '待机',
                    2: '故障',
                    3: '维护',
                };
            } else if (item.prop === 'settlementMode') {
                valueFormat = {
                    0: '时间沉降',
                    1: '动态沉降',
                };
            }
            else if (item.prop === 'settlementMode') {
                valueFormat = {
                    0: '时间沉降',
                    1: '动态沉降',
                };
            }else if (item.prop === 'powerType') {
                valueFormat = {
                    0: '市电',
                    1: 'UPS',
                };
            }else if (item.prop === 'workStatus') {
                valueFormat = {
                    0: '空闲',
                    1: '加标回收',
                    2: '其它',
                };
            }else if (item.prop === 'onlineStatus') {
                valueFormat = {
                    0: '正常',
                    1: '异常',
                };
            }
            return valueFormat[item.value] || item.value;
        }
    }
}
</script>

<style scoped>
.system-parameter {
    display: flex;
    height: 100%;
    padding: 6px;
    gap: 12px;
}

.frame-content {
    flex: 1;
    height: 100%;

    .frame-content-title {
        font-size: 16px;
        color: #c3ebff;
        padding-left: 10px;
        display: inline-block;
        margin-right: 10px;
        position: relative;
        margin-bottom: 8px;

        &::before {
            content: '';
            position: absolute;
            display: block;
            width: 4px;
            height: 16px;
            background-color: #02fb71;
            left: 0;
            top: 3px;
        }
    }

    .parameter-title {
        color: #fff;
        font-size: 16px;
        margin: 5px 0;
    }

    .frame-content-card {
        height: calc(100% - 31px);
        padding: 16px;
        border: 1px solid #02338a;
        box-shadow: 0px 0px 15px 0 rgba(67, 167, 253, 0.8) inset;
        border-radius: 6px;
        overflow: auto;
    }

    .parameter-card {
        margin-bottom: 20px;
    }

    .parameter-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .parameter-item {
        width: calc(100% / 6);
        box-sizing: border-box;

        font-size: 14px;
        color: #fff;
        line-height: 30px;
        white-space: nowrap;
        padding: 0px 10px;
    }

    .param-label {
        color: #36adfe;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 4px;
    }
}

</style>
